module.exports = __webpack_public_path__ + "img/077f9db.jpg";